/**
 * IA Token Guard
 *
 * Protects the /app/iaassist route from direct URL access when the user
 * has not gone through the IA authentication flow (token_ia absent).
 *
 * Normal flow: user clicks "Sara" button in the sidebar → sidebar calls
 * authenticationIa(), stores token_ia, then navigates to /app/iaassist.
 *
 * Direct URL access (e.g. typing the URL after a hard refresh when the IA
 * session expired): redirect to /app so the user can re-authenticate via
 * the sidebar button.
 */

import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const iaTokenGuard: CanActivateFn = (): boolean => {
  const router = inject(Router);
  const iaToken = localStorage.getItem('token_ia');

  if (iaToken) {
    return true;
  }

  // No IA token — send the user to the private home so the sidebar is
  // visible and they can trigger the IA login flow normally.
  router.navigate(['/app']);
  return false;
};
